import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import StyledLink from './style';
import Text from '../Text';

/**
 * @desc Text Component with 'Read More' and 'Show Less' functionality
 *
 *
 * @param string $text: The text you want to display
 * @param integer $limit: The length at which you need to stop showing the 'text' followed by ...
 * @param string $color: Color of the 'text'
 *
 * @return Component ReadMore
 */

function ReadMore({ text, limit, color, t }) {
  const [isReadMore, setIsReadMore] = useState(true);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const textComponent = textContent => <Text color={color}>{textContent}</Text>;

  return (
    <>
      {isReadMore
        ? textComponent(`${text.slice(0, limit)}...`)
        : textComponent(text)}
      <br />
      <StyledLink onClick={toggleReadMore} underline="always">
        {isReadMore ? t('common.readMore') : t('common.showLess')}
      </StyledLink>
    </>
  );
}

ReadMore.defaultProps = {
  text: '',
  color: null,
  limit: 300,
};

ReadMore.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  limit: PropTypes.number,
};

export default withTranslation()(ReadMore);
